module.exports = __webpack_public_path__ + "static/img/icon_default_store_head_img.6cdcc1f6.png";